// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"b7d57042","69":"58ec0037","141":"9713fe14","171":"2d7d56dd","214":"b16b00ee","232":"dee1cc4d","295":"c40453ed","454":"1a0bfb00","534":"c90eda93","700":"1f1d7d05","716":"82efe043","778":"d6651097","810":"aeaf39b3","824":"4f43ca28","877":"0c9a8fab","899":"5e45dd34"}[chunkId] + ".chunk.js";
};